var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOk = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 101.22 102.34"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "ok_svg__a",
  x1: 2096.21,
  y1: -396.43,
  x2: 2197.42,
  y2: -396.43,
  gradientTransform: "matrix(1 0 0 -1 -2096.22 -345.24)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#dbdbdb"
})))), /*#__PURE__*/React.createElement("path", {
  d: "M50.6 0a50.6 50.6 0 0 1 50.6 50.6v1.1A50.61 50.61 0 1 1 0 51.81v-1.19A50.61 50.61 0 0 1 50.6 0Z",
  style: {
    fillRule: "evenodd",
    opacity: 0.2,
    isolation: "isolate",
    fill: "url(#ok_svg__a)"
  }
}));
export { SvgOk as ReactComponent };
export default __webpack_public_path__ + "static/media/ok.ddc04f49.svg";